import {PlayersStatisticsTableGroupApiModel} from "./players-statistics.table.group.api-model";
import {BaseDomainModel} from "../../../../../../infrastructure/models/base-domain-model";

export class PlayersStatisticsTableGroupDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsTableGroupApiModel;

  get name(): String {
    return this.apiModel.name;
  }
}
